module.exports = {"id":"235634","name":"Ghislain Konan","rating":"75","photo":"./data/images/photos/2/235634.png","club":{"name":"Vit. Guimarães","logo":"./data/images/clubs/Vit.Guimaraes.png"},"positions":["DG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GhislainKonan0.json
// module id = 1579
// module chunks = 0